import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import axios from "axios";
import { red } from "@mui/material/colors";

// CSS
import "../App.css";
import "../style/default.css";
import "../style/product.css";

import prod_img from "../assets/products/35mm_film_colorprints_lab_template.jpg";

const LineBreakText = ({ text }) => (
  <>
    {text.split("\n").map((line, i) => (
      <span key={i}>
        {line}
        <br />
      </span>
    ))}
  </>
);

function Product() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [cartItems, setCartItems] = useState([]);
  const [faveItems, setFaveItems] = useState([]);
  const [isFaveItem, setIsFaveItem] = useState(false);
  const [mainImage, setMainImages] = useState(0); // { prod_id: "img1.jpg" }

  // // Load existing cart items from localStorage on page load
  // useEffect(() => {
  //   // Retrieve the cart from localStorage when the component mounts
  //   const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
  //   setCartItems(storedCart); // Set the retrieved items in state
  // }, []); // This useEffect will only run once on initial render

  const handleImageClick = (prodNum) => {
    setMainImages(prodNum);
  };

  useEffect(() => {
    const fetchFaves = async () => {
      try {
        const response = await fetch(`${baseURL}/fetch-User`, {
          method: "GET",
          credentials: "include",
        });
        const data = await response.json();

        const fetchedFaves = data.faveItems;
        setFaveItems(fetchedFaves);

        const found = fetchedFaves.some(
          (item) => Number(item.prod_id) === Number(id),
        );
        setIsFaveItem(found);
      } catch (error) {
        console.error("Error fetching favorites:", error);
      }
    };

    axios
      .get(`${baseURL}/product/${id}`)
      .then((response) => {
        setProduct(response.data);
      })
      .catch((error) => {
        console.error("Error fetching product:", error);
      });

    fetchFaves();
  }, [id]);

  useEffect(() => {
    const fetchCart = async () => {
      try {
        const response = await fetch(`${baseURL}/cart-view`, {
          method: "GET",
          credentials: "include",
        });
        const data = await response.json();
        setCartItems(data.cartItems || []);
      } catch (error) {
        console.error("Error fetching cart:", error);
      }
    };

    fetchCart();
  }, []);

  // const addToFave = async (newItem) => {
  //   // Check if user is logged in (modify this check based on your auth logic)
  //   const userLoggedIn = document.cookie.includes("refreshToken"); // Example check if using cookies

  //   if (!userLoggedIn) {
  //     if (
  //       window.confirm(
  //         "You need to login or sign up first. Click OK to go to Sign In."
  //       )
  //     ) {
  //       window.location.href = "http://thevintagecollective.shop/auth/login";
  //     }
  //     return;
  //   }

  //   const updatedList = [...faveItems]; // Copy current cart items

  //   updatedList.push({ prod_id: newItem.prod_id });

  //   // Update local state
  //   setFaveItems(updatedList);

  //   // Send updated cart to the server
  //   try {
  //     await fetch(`${baseURL}/user/wishlist`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ faveItems: updatedList }),
  //       credentials: "include",
  //     });
  //   } catch (error) {
  //     console.error("Error saving to database:", error);
  //   }
  // };

  // const addToFave = async (newItem) => {
  //   const updatedList = [...faveItems, { prod_id: newItem.prod_id }];
  //   setFaveItems(updatedList);

  //   await fetch(`${baseURL}/user/wishlist`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     credentials: "include",
  //     body: JSON.stringify({ faveItems: updatedList }), // ✅ not old state
  //   });
  // };

  // const removeToFave = async (newItem) => {
  //   const updatedList = faveItems.filter(
  //     (item) => item.prod_id !== newItem.prod_id
  //   );
  //   setFaveItems(updatedList);

  //   await fetch(`${baseURL}/user/wishlist`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     credentials: "include",
  //     body: JSON.stringify({ faveItems: updatedList }), // ✅ not old state
  //   });
  // };

  const toggleFave = async (newItem) => {
    try {
      const authResponse = await fetch(`${baseURL}/checkAuth`, {
        method: "GET",
        credentials: "include",
      });

      if (!authResponse.ok) {
        if (window.confirm("Login or Create an Account")) {
          window.location.href = "http://thevintagecollective.shop/auth/login";
        }
        return;
      }

      let updatedList = [];

      const exists = faveItems.some(
        (item) => Number(item.prod_id) === Number(id),
      );

      setIsFaveItem(exists);

      if (exists) {
        // Remove if it exists
        updatedList = faveItems.filter(
          (item) => Number(item.prod_id) !== Number(id),
        );
      } else {
        // Add if not existing
        updatedList = [...faveItems, { prod_id: id }];
      }

      setFaveItems(updatedList);

      await fetch(`${baseURL}/user/wishlist`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ faveItems: updatedList }), // ✅ always send updated list
      });

      // ✅ Reload page only after successful response
      window.location.reload();
    } catch (error) {
      console.error("Error toggling favorite:", error);
    }
  };

  const handleSendCartData = async () => {
    try {
      const response = await fetch(`${baseURL}/user/add-cart`, {
        method: "POST",
        credentials: "include", // This is needed to send the cookie
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          prod_id: id,
          prod_quan: quantity,
        }),
      });

      if (response.status === 401) {
        alert("You must be logged in to add items to your cart.");
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      alert("Cart updated successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Error sending cart data:", error);
      alert("Something went wrong while updating the cart.");
    }
  };

  const handleQuantityChange = async (newQuantity) => {
    if (!isNaN(newQuantity)) {
      const clamped = Math.max(1, Math.min(20, newQuantity));
      setQuantity(clamped);
    }
  };

  if (!product) {
    return <div>Loading...</div>;
  }

  return (
    <div className="Product">
      <div className="prod-img-grid flex-item">
        <div className="backButton">
          {" "}
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={`/catalogue?keyword=${encodeURIComponent(
                product.prod_category,
              )}`}
            >
              {product.prod_category}
            </Link>
            <Typography sx={{ color: "text.primary" }}>
              {product.prod_name}
            </Typography>
          </Breadcrumbs>
        </div>
        <div className="img">
          <img
            src={JSON.parse(product.prod_image)[mainImage]}
            alt={`Main ${mainImage}`}
          />
        </div>
        {/* Thumbnail Images */}
        <div
          style={{ display: "flex", gap: "5px", marginTop: "8px" }}
          className="thumbnail-row"
        >
          {JSON.parse(product.prod_image).map((img, imgIndex) => (
            <img
              key={imgIndex}
              src={img}
              alt={`Thumbnail ${imgIndex}`}
              onClick={() => handleImageClick(imgIndex)}
              className="thumbnail-img"
            />
          ))}
        </div>
        {/* <div className="img-prev-grid">
          <div className="img-prev">
            <img src={product.prod_image} alt="Product Image"></img>
          </div>
          <div className="img-prev">
            <img src={product.prod_image} alt="Product Image"></img>
          </div>
        </div> */}

        <div className="favoriteButton">
          {isFaveItem ? (
            <FavoriteIcon
              onClick={() => toggleFave(product)}
              sx={{ color: red[500], cursor: "pointer", px: 0.4 }}
            />
          ) : (
            <FavoriteBorderIcon
              onClick={() => toggleFave(product)}
              sx={{ cursor: "pointer", px: 0.4 }} // default black
            />
          )}
          Favorite
        </div>
      </div>

      <div className="prod-desc-grid flex-item">
        <div className="prod-name left hundred">
          <h1>{product.prod_name}</h1>
        </div>
        <div className="prod-atc-price sub-header left hundred">
          {product.prod_sale > 0 ? (
            <span>
              <strike style={{ color: "red" }}>
                <b>₱{product.prod_price}</b>
              </strike>{" "}
              <b style={{ color: "red" }}>₱{product.prod_sale} Sale</b>
            </span>
          ) : product.prod_stock <= 0 ? (
            <span>
              <strike style={{ color: "red" }}>
                <b>₱{product.prod_price}</b>
              </strike>{" "}
            </span>
          ) : (
            <b>₱{product.prod_price}</b>
          )}
        </div>
        <Box sx={{ py: 1 }}>
          <Grid
            container
            direction="row"
            spacing={{ xs: 1, m: 2 }}
            alignItems={"center"}
          >
            {" "}
            <TextField
              id="outlined-number"
              label="Quantity"
              type="number"
              defaultValue={1} // Sets default to 1
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
                htmlInput: {
                  min: 1,
                  max: 20,
                  step: 1,
                },
              }}
              // onChange={(e) => {setQuantity(Number(e.target.value))}}

              onChange={(e) => {
                handleQuantityChange(Number(e.target.value));
              }}
            />
            {product.prod_stock > 0 ? (
              <div className="prod-atc-btn">
                <button onClick={() => handleSendCartData(product)}>
                  {product.prod_preorder == "yes" ? "Pre-Order" : "Add to Cart"}
                </button>
              </div>
            ) : (
              <div className="prod-atc-btn">
                <button disabled>Sold Out</button>
              </div>
            )}
          </Grid>{" "}
        </Box>

        {/* <div className="prod-promo">
          <h2>Buy more and Save!</h2>
          <br />
          <span>Buy 4 and Get 25% Discount!</span>
        </div> */}
        <div className="prod-desc left hundred">
          Key Features{" "}
          <p>
            <ul>
              {product.prod_features.split("/").map((feat) => (
                <li>{feat}</li>
              ))}
            </ul>
            <br />
            <LineBreakText text={product.prod_desc} />

            <br />
            <br />
          </p>
        </div>
        <div className="prod-soc-btn"></div>
      </div>
    </div>
  );
}

export default Product;
